"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var _wouter = require("wouter");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _common = require("../../store/common");
var _Style = require("../../style/Style");
var _lesson = require("../../store/lesson");
var _Lesson = require("../../model/Lesson");
var _UserLesson = require("../../model/UserLesson");
var _user = require("../../store/user");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//import { Button } from '@mui/base';
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const [lesson, setLesson] = (0, _react.useState)(new _Lesson.Lesson());
  const [userLesson, setUserLesson] = (0, _react.useState)(new _UserLesson.UserLesson());
  const lastUpdateTime = new Date();
  const {
    isLoading,
    setIsLoading,
    setToastText,
    setToastOpen,
    onLoggedIn,
    setOnLoggedIn
  } = (0, _common.useCommonStore)();
  const {
    currentUser
  } = (0, _user.useUserStore)();
  const {
    userAnswers,
    isScoring,
    setUserAnswers,
    scoring
  } = (0, _lesson.useLessonStore)();
  (0, _react.useEffect)(() => {
    (async () => {
      if (!currentUser || !currentUser.id) {
        setToastText('ユーザー情報が見つかりませんでした。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      if (!currentUser.companyId) {
        setToastText('ユーザー情報に問題があります。再度ログインしてください。');
        setToastOpen(true);
        setLocation('/login');
        return;
      }
      if (!props.courseId) {
        setLocation('/courses');
        setToastText('コースが見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      if (!props.lessonId) {
        setLocation(`/course/detail/${props.courseId}`);
        setToastText('教材が見つかりませんでした。');
        setToastOpen(true);
        return;
      }
      setIsLoading(true);
      const newLesson = await _Lesson.Lesson.getByID(props.lessonId);
      const currentUserLesson = await _UserLesson.UserLesson.getByID(currentUser.id, props.lessonId);
      if (!currentUserLesson.id) {
        userLesson.init(currentUser.id, currentUser.companyId, props.courseId, props.lessonId);
      }
      if (!currentUserLesson.isCompleted) {
        setLocation(`/course/detail/${props.courseId}`);
        setToastText(`単元「${lesson.name}」を修了していないため、修了テストが開始できません。`);
        setToastOpen(true);
        return;
      }
      setUserLesson(currentUserLesson);
      await newLesson.fetchExamQuestions();
      setLesson(newLesson);
      setIsLoading(false);
    })();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 2,
    alignItems: 'center',
    justifyContent: 'center',
    ...stylex.props(_Style.wrapper.main),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
      ...stylex.props(_Style.buttonStyle.secondary),
      onClick: () => {
        window.history.back();
      },
      children: "\uFF1C\u623B\u308B"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "row",
      alignItems: 'center',
      justifyContent: 'center',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.chipStyle.common, userLesson.isPassedExam ? _Style.chipStyle.active : _Style.chipStyle.inactive),
        children: userLesson.isPassedExamText
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: ["\u5358\u5143\u300C", lesson.name, "\u300D \u4FEE\u4E86\u30C6\u30B9\u30C8"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ...stylex.props(_Style.textStyle.paragraph1),
      children: lesson.detail
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u53D7\u8B1B\u958B\u59CB\u65E5\u6642: ", userLesson.startedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u53D7\u8B1B\u5B8C\u4E86\u65E5\u6642: ", userLesson.completedAtText]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: ["\u4FEE\u4E86\u65E5\u6642: ", userLesson.examPassedAtText]
    }), lesson.examQuestions && lesson.examQuestions.length > 0 && lesson.examQuestions.map((question, index) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
        container: true,
        direction: "column",
        spacing: 2,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          ...stylex.props(_Style.textStyle.h3),
          children: [index + 1, ". ", question.question]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Stack, {
          direction: "column",
          spacing: 2,
          ...stylex.props(_Style.wrapper.stretchW),
          children: question.answers.map((answer, answerIndex) => {
            const checked = userAnswers[index] === answerIndex;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Button, {
              ...stylex.props(checked ? _Style.buttonStyle.primary : _Style.buttonStyle.secondary),
              onClick: () => {
                if (checked) return;
                const newAnswers = [...userAnswers];
                newAnswers[index] = answerIndex;
                setUserAnswers(newAnswers);
              },
              children: [answerIndex + 1, ".", answer]
            });
          })
        })]
      });
    }), lesson.examQuestions && lesson.examQuestions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      direction: "row",
      justifyContent: 'center',
      alignItems: 'center',
      ...stylex.props(_Style.wrapper.stretchW, _Style.marginStyle.top),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Button, {
        onClick: async () => {
          // 全回答チェック
          const isAnswered = (() => {
            const len = userAnswers.length;
            if (lesson.examQuestions && len !== lesson.examQuestions.length) return false;
            for (let i = 0; i < len; i++) {
              if (userAnswers[i] === undefined) return false;
            }
            return true;
          })();
          if (!isAnswered) {
            setToastText('全ての問題に回答してください。');
            setToastOpen(true);
            return;
          }
          if (!window.confirm('採点してよろしいでしょうか？修了テストはいつでも受けられます。')) return;
          setIsLoading(true);
          await scoring(userLesson.lessonId, userLesson.userId);
          setLocation(`/course/${lesson.courseId}/lesson/${userLesson.lessonId}/exam-result`);
          setIsLoading(false);
        },
        ...stylex.props(_Style.textStyle.h3, isScoring ? _Style.buttonStyle.disabled : _Style.buttonStyle.primary, _Style.wrapper.stretchW),
        disabled: isScoring,
        children: isScoring ? "採点中..." : "採点する"
      })
    }) : "読み込み中..."]
  });
}; // <div {...stylex.props(chipStyle.common, chipStyle.inactive)}>未受講</div>*/
var _default = exports.default = App;